//-------------------------------------------------------------------------------------------------- Imports
import { Row, Col, Card, Typography } from "antd";
import { StyleSheet } from "../../StyleSheet";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { images } from "../../routes/ImageRoutes";
const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- View
const ContactAgent = () => {
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            const newIdCliente = generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor;
            setIdCliente(newIdCliente);
        }
    }, [generalData.selectedContract]);

    return (
        <Row style={styles.rowRoot}>
            <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                <Card bodyStyle={{ justifyContent: 'center' }} style={{ ...styles.cardRoot, marginTop: 10 }} >
                    <Row style={{ ...styles.rowRoot, marginBottom: 20 }}>
                        <Col xs={16} xl={16} style={styles.colRoot}>
                            <Text style={styles.textPrincipal}>
                                Puede contactar a soporte marcando al número o por medio de Whatsapp.
                            </Text>
                        </Col>
                    </Row>
                    <Row style={{ ...styles.rowRoot, marginBottom: 20 }}>
                        <Col xs={16} xl={16} style={styles.colRoot}>
                            <Text style={styles.textPrincipal}>
                                Soporte por llamada: 33969-00000
                            </Text>
                        </Col>
                    </Row>
                    <Row style={{ ...styles.rowRoot, marginBottom: 20 }}>
                        <div
                            style={styles.imageContainer}
                            onClick={(e) => {
                                e.preventDefault();
                                window.open('http://api.whatsapp.com/send?phone=523396900001&text=Buenas tardes! Mi número de suscriptor es: ' + idCliente);
                            }}
                        >
                            <img
                                src={images.iconWhatsAppSupport}
                                alt="whatsapp"
                                style={styles.whatsappIcon}
                            />
                        </div>
                    </Row>
                </Card>
            </Col>
        </Row>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardRoot: {
        backgroundColor: 'white',
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20
    },
    colRoot: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 5
    },
    rowRoot: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 10
    },
    textPrincipal: {
        textAlign: 'center',
        fontFamily: "Montserrat",
        fontWeight: 600,
        fontSize: 14
    },
    imageContainer: {
        display: "flex",
        width: 50,
        height: 70,
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    whatsappIcon: {
        height: 50,
        borderRadius: 30,
        boxShadow: "4px 4px 4px 1px #00000029"
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ContactAgent;
